import { motion } from "framer-motion";

/**
 * Reusable scroll-reveal wrappers — drop one of these around any element
 * you want to animate when it enters the viewport.
 */

const easing = [0.22, 1, 0.36, 1];

// Pop in from the bottom with a tiny scale bounce
export const PopIn = ({ children, delay = 0, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y: 40, scale: 0.94 }}
    whileInView={{ opacity: 1, y: 0, scale: 1 }}
    viewport={{ once, amount: 0.25 }}
    transition={{ duration: 0.75, delay, ease: easing }}
    className={className}
  >
    {children}
  </motion.div>
);

// Slide from the left
export const SlideLeft = ({ children, delay = 0, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, x: -50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once, amount: 0.3 }}
    transition={{ duration: 0.75, delay, ease: easing }}
    className={className}
  >
    {children}
  </motion.div>
);

// Slide from the right
export const SlideRight = ({ children, delay = 0, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, x: 50 }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once, amount: 0.3 }}
    transition={{ duration: 0.75, delay, ease: easing }}
    className={className}
  >
    {children}
  </motion.div>
);

// Mask-reveal — element clipped from below, then sweeps up
export const MaskUp = ({ children, delay = 0, className = "", once = true }) => (
  <div className="overflow-hidden">
    <motion.div
      initial={{ y: "110%" }}
      whileInView={{ y: 0 }}
      viewport={{ once, amount: 0.4 }}
      transition={{ duration: 0.9, delay, ease: easing }}
      className={className}
    >
      {children}
    </motion.div>
  </div>
);

// Staggered children — wrap a list and apply `StaggerItem` to each child
export const StaggerGroup = ({ children, delay = 0, className = "", once = true }) => (
  <motion.div
    initial="hidden"
    whileInView="show"
    viewport={{ once, amount: 0.2 }}
    transition={{ staggerChildren: 0.09, delayChildren: delay }}
    variants={{ hidden: {}, show: {} }}
    className={className}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "" }) => (
  <motion.div
    variants={{
      hidden: { opacity: 0, y: 30, scale: 0.95 },
      show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.65, ease: easing } },
    }}
    className={className}
  >
    {children}
  </motion.div>
);
